import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { AiRovoButtonNodeProvider } from './AiRovoButtonNodeProvider.tsx';

export const AiRovoButtonNodeProviderWithBoundary = (): React.JSX.Element | null => {
	return (
		<JSErrorBoundary
			fallback="unmount"
			id="ai-rovo-button-node-provider"
			packageName="ai-rovo-button"
			teamName="reverie"
		>
			<AiRovoButtonNodeProvider />
		</JSErrorBoundary>
	);
};
